import { Injectable } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { RAW_STATUSES } from './statistics-dropdown.constant';
import { BehaviorSubject, Observable } from 'rxjs';

export interface StatusInfo {
  svg: SafeHtml;
  title: string;
  slug: string;
}

@Injectable({
  providedIn: 'root',
})
export class UserStatusService {
  private statusMap: Map<string, StatusInfo> = new Map();
  private currentStatus: StatusInfo | null = null; // Holds the current status

  private statusSubject = new BehaviorSubject<StatusInfo | null>(null);
  public status$: Observable<StatusInfo | null> = this.statusSubject.asObservable();

  constructor(private sanitizer: DomSanitizer) {
    this.initializeStatusMap();
  }

  private initializeStatusMap(): void {
    RAW_STATUSES.forEach((status: any) => {
      this.statusMap.set(status.slug, {
        svg: this.sanitizer.bypassSecurityTrustHtml(status.svg),
        title: status.title,
        slug: status.slug, // Store slug in the status info
      });
    });
  }

  // Get the current status
  getCurrentStatus(): StatusInfo | null {
    return this.currentStatus;
  }

  // Get just the current status SVG
  getCurrentStatusSvg(): SafeHtml | null {
    return this.currentStatus?.svg || null;
  }

  // Set the current status
  setCurrentStatus(statusSlug: string): void {
    const statusInfo = this.statusMap.get(statusSlug);
    if (statusInfo) {
      this.currentStatus = statusInfo;

      this.statusSubject.next(statusInfo);
    }
  }

  // Get status info by slug
  getStatusInfoBySlug(statusSlug: string): StatusInfo | undefined {
    return this.statusMap.get(statusSlug);
  }

  // Get just the SVG for a specific status
  getSvgBySlug(statusSlug: string): SafeHtml | null {
    return this.statusMap.get(statusSlug)?.svg || null;
  }

  getStatusBySlug(slug: any) {
    return RAW_STATUSES.find((x: any) => x.slug == slug);
  }
}
